import { Category, GQL_ID } from '@@types'
import { gql, useQuery } from '@apollo/client'

type CategoryData = {
  category: Category
}

interface BasicProps {
  shop_id: GQL_ID
}

interface CategoryIdProp extends BasicProps {
  id: GQL_ID
  slug?: string
}

interface CategorySlugProp extends BasicProps {
  slug?: string
  id?: never
}

type CategoryVariables = CategoryIdProp | CategorySlugProp

export const GQL_QUERY_CATEGORY = gql`
  query category ($shop_id: ID!, $id: ID, $slug: String) {
    category(shop_id: $shop_id, id: $id, slug: $slug) {
      id
      name
      slug
      parent {
        id
        name
        slug
      }
      altIcon {
        url
      }
    }
  }
`

export const useCategory = (
  { shop_id, id, slug }: CategoryVariables,
  options?: Parameters<typeof useQuery<CategoryData, CategoryVariables>>[1],
) => {
  const { data, loading, error, refetch } = useQuery<CategoryData, CategoryVariables>(
    GQL_QUERY_CATEGORY,
    {
      variables: {
        shop_id,
        id,
        slug,
      },
      skip: options?.skip ?? !shop_id,
      ...options,
    },
  )

  const category = data?.category

  return {
    category,
    data,
    loading,
    error,
    refetch
  }
}
